import React from 'react';
import {Styles} from '../../../config/design/styles';
import {getDataTableLocalization} from "../../../config/Translate";
import axios from "axios";
import {defaultVariables} from "../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../config/design/TableIcons";
import AddFile from "./Components/AddFile";
import {TableCount, TablePage} from "../../../config/Permissions";
import {showTableDate, translateKey, truncate} from "../../../config/values";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Avatar from '@mui/material/Avatar';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    IconButton,
    List,
    ListItem, ListItemAvatar, ListItemText,
    MenuItem,
    TextField, Typography
} from "@mui/material";
import {
    DescriptionRounded,
    ExpandMoreRounded, FilterListRounded, GetApp,
    GifRounded,
    OndemandVideoRounded, OpenInNew,
    PlayCircleFilledOutlined
} from "@mui/icons-material";
import Button from "@mui/material/Button";
import SubTitle from "../../components/elements/SubTitle";
import Role from "../../components/elements/Role";
import {withStyles} from "@mui/styles";
import LinkIcon from "@mui/icons-material/Link";


class FileManager extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        owner: 'self',
        type:  this.props.fileType !== undefined ? this.props.fileType : 'image',
        fileType : this.props.fileType !== undefined ? this.props.fileType : 'image',
        columns: [
            {
                field: 'source',
                editable: 'never',
                title: translateKey('image'),
                render: rowData =>(
                    rowData.type === 'image' ? rowData.extension === 'gif' ? <GifRounded style={{fontSize: 40,color: "#6d6d6d"}}/> : <img className={this.classes.FMThumbnail} alt="avatar" src={rowData.thumbnail} /> :
                        rowData.type === 'video' ?
                            !!rowData.preview ?
                                <div className={this.classes.thumbnailWithPreview}>
                                    <img className={this.classes.FMThumbnail} alt="avatar" src={rowData.preview} />
                                    <PlayCircleFilledOutlined style={{fontSize: 30,color: "#6d6d6d",opacity:0.7}}/>
                                </div>
                                :
                                <OndemandVideoRounded style={{fontSize: 40,color: "#6d6d6d"}}/> :
                            <DescriptionRounded style={{fontSize: 40,color: "#6d6d6d"}}/>
                )
            },
            {
                title: translateKey('imageName'),
                field: 'ImageName' ,
                editable: 'never',
                render: rowData =>(
                    rowData.ImageName+"."+rowData.extension
                )

            },
            {
                title: translateKey('alt'),
                hidden: this.props.user.role.type !== "admin" || (this.props.width === "sm" || this.props.width === "xs"),
                field: 'alt' ,
                render: rowData =>(
                    truncate(rowData.alt,18)
                )
            },
            { title: translateKey('ownerMedia'),editable: 'never', field: 'owner',hidden: this.props.width === "sm" || this.props.width === "xs",},
            { title: translateKey('uploadedDate'),
                editable: 'never',
                field: 'lastUpdate',
                hidden: this.props.width === "sm" || this.props.width === "xs",
                render: rowData =>
                    <Typography className={this.classes.dateTable}>
                        {showTableDate(rowData.created_at)}
                    </Typography>
            },
            {
                title: translateKey('link'),editable: 'never',
                field: 'link',
                hidden : !this.props.page,
                render: rowData =>(
                    rowData.type === 'image' ? <IconButton color="secondary" onClick={() => this.OpenDialog(rowData)}><LinkIcon /></IconButton> : rowData.extension === "youtube" ? <IconButton target="_blank" component="a" href={`${defaultVariables.youtube}${rowData.source_id}`}><OpenInNew color="primary"/></IconButton> :  <IconButton component="a" href={rowData.source}><GetApp color="primary" /></IconButton>
                )
            },
            {
                title: translateKey('activity'),
                editable: 'never',
                field: 'action',
                hidden: !this.props.selection,
                render: rowData =>(
                    <Button color="secondary" variant="outlined" size="small" startIcon={<GetApp/>}>
                        {translateKey('insert')}
                    </Button>
                )
            },
        ],
        data: [],
        ChangeLoader:false,
        LinkDialog:false,
        links:null,
        open_filter:false,
    };
    componentDidMount(){
    }
    OpenDialog(data){
        let links = []
        links[0] = `${defaultVariables.uploads}/FileManager/${data.name}_small.${data.extension}`;
        links[1] = `${defaultVariables.uploads}/FileManager/${data.name}_medium.${data.extension}`;
        links[2] = `${defaultVariables.uploads}/FileManager/${data.name}.${data.extension}`;
        this.setState({
            links,
            LinkDialog:true
        })
    }
    handleCloseDialog(){
        this.setState({
            LinkDialog:false
        })
    }
    handleClickLink(link){
        navigator.clipboard.writeText(link);
        this.setState({
            LinkDialog:false
        })

    }
    addImage(data){
        const {handleSetImage} = this.props;
        if(handleSetImage !== undefined){
            handleSetImage(data)
        }
    }

    upload(image,preview = null){
        const {handleSetImage} = this.props;
        if(handleSetImage !== undefined){
            handleSetImage(image,preview)
        }
        if(preview === null) this.loadData();
    }
    handlePreview(image){
        const {handleSetPreview} = this.props;
        if(handleSetPreview !== undefined){
            handleSetPreview(image)
        }
    }
    Changed(){
        this.loadData();
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }

    async onDeleteFile(id,hasNotif = true) {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariables.url}/file/remove`, data, config)
            .then(response => {
                if(response.status === 403){

                }else{
                    if(response.data.hasError){

                    }else{
                        if(hasNotif){

                        }
                    }
                }

                this.loadData();

                return true
            })
            .catch(error => {
                console.log(error.response)

                return false
            });
    }
    async onDeleteSelectedFiles(data){
        await data.map((row) =>(
            this.onDeleteFile(row.id,false)

        ));
        await this.loadData();


    }
    onEditFile(file) {
        let data = new FormData();
        data.append('id', file.id);
        data.append('alt', file.alt);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariables.url}/file/edit`, data, config)
            .then(response => {

                this.loadData();
                return true
            })
            .catch(error => {

                return false
            });
    }
    handleChangeLoader(){
        this.setState({
            ChangeLoader:!this.state.ChangeLoader
        })
    }
    async handleChangeOwner(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let owner = target.value;
        await this.setState({
            owner
        });
        this.loadData();
    }
    async handleChangeType(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let type = target.value;
        await this.setState({
            type
        });
        this.loadData();
    }
    onSelected(data){
        data.map((row) =>(
            this.addImage(row)
        ));
    }
    render(){

        let {LinkDialog,links,fileType,type,owner,open_filter} = this.state;
        let {user,modal} = this.props;
        let loginToken = localStorage.getItem('ACT');
        const data = new FormData();
        data.append('type', type);
        data.append('owner', owner);
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <Container maxWidth="xl">
                <Grid container spacing={2}>
                    <Grid item size={12} className="file-manager-table main-table">
                        <MaterialTable
                            tableRef={this.tableRef}
                            icons={tableIcons}
                            onRowClick={((evt, selectedRow) =>  this.addImage(selectedRow))}
                            localization={getDataTableLocalization()}
                            title={
                                <AddFile
                                    ChangeLoader={this.handleChangeLoader.bind(this)}
                                    upload={this.upload.bind(this)}
                                    handlePreview={this.handlePreview.bind(this)}
                                    type={this.props.fileType}
                                    single={this.props.single}
                                    defined_width={this.props.defined_width}
                                    defined_height={this.props.defined_height}
                                />
                            }
                            columns={this.state.columns}
                            data={query =>
                                new Promise((resolve, reject) => {
                                        axios.post(`${defaultVariables.url}/file/getAll?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}&only_file=${!!this.props.onlyFile ? "yes" : 'no'}&width=${!!this.props.defined_width ? this.props.defined_width : ''}&height=${!!this.props.defined_height ? this.props.defined_height : ''}`, data, config)
                                            .then(response => {
                                                let data = [];
                                                response.data.data.map((row) =>(
                                                    data.push({
                                                        thumbnail: `${defaultVariables.uploads}/FileManager/${row.name}_small.${row.extension}`,
                                                        source: `${defaultVariables.uploads}/FileManager/${row.name}.${row.extension}`,
                                                        ImageName: truncate(row.name,20),
                                                        name: row.name,
                                                        extension: row.extension,
                                                        alt: row.alt,
                                                        type: row.type,
                                                        source_id: row.source_id,
                                                        owner: row.owner.first_name+" "+row.owner.last_name,
                                                        id: row.id,
                                                        created_at:row.updated_at
                                                    })
                                                ));
                                                resolve({
                                                    data: data,
                                                    page: response.data.current_page - 1,
                                                    totalCount: response.data.total,
                                                })

                                            }).catch(error => {
                                            console.log(error.response)
                                        });
                                    }
                                )
                            }
                            options={{
                                selection:false,
                                pageSize: TablePage,
                                pageSizeOptions: TableCount,
                                sorting:false,
                                search:true,
                                draggable:false,
                            }}
                            editable={this.props.width === "sm" || this.props.width === "xs" ? null :
                                {
                                    onRowDelete: oldData =>
                                        new Promise(resolve => {
                                            setTimeout(() => {
                                                resolve();
                                                this.onDeleteFile(oldData.id);
                                                this.setState(prevState => {
                                                    const data = [...prevState.data];
                                                    data.splice(data.indexOf(oldData), 1);
                                                    return { ...prevState, data };
                                                });
                                            }, 600);
                                        }),
                                }
                            }
                        />
                    </Grid>
                </Grid>
                <Dialog onClose={this.handleCloseDialog.bind(this)}  open={LinkDialog}>
                    <DialogTitle>{translateKey('ChooseImageLink')}</DialogTitle>
                    {
                        LinkDialog ?
                            <List>
                                <ListItem button onClick={() => {this.handleClickLink(links[0])}}>
                                    <ListItemText style={{textAlign:"left"}} primary={links[0]} />
                                    <ListItemAvatar style={{direction:"ltr"}}>
                                        <Avatar src={links[0]} className={this.classes.small}/>
                                    </ListItemAvatar>
                                </ListItem>
                                <ListItem button onClick={() => {this.handleClickLink(links[1])}}>
                                    <ListItemText style={{textAlign:"left"}}  primary={links[1]} />
                                    <ListItemAvatar style={{direction:"ltr"}}>
                                        <Avatar src={links[1]}/>
                                    </ListItemAvatar>
                                </ListItem>
                                <ListItem  button onClick={() => {this.handleClickLink(links[2])}}>
                                    <ListItemText style={{textAlign:"left"}} primary={links[2]} />
                                    <ListItemAvatar style={{direction:"ltr"}}>
                                        <Avatar src={links[2]} className={this.classes.large}/>
                                    </ListItemAvatar>
                                </ListItem>
                            </List>
                            : null
                    }
                </Dialog>
            </Container>

        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    locale: state.locale
});
export default withStyles(Styles)(connect(mstp)(FileManager));
